import { getAccountPermalink } from '~/lib'

export default defineNuxtRouteMiddleware(async () => {
  try {
    const localePath = useLocalePath()
    const { refreshUser, isLoggedIn } = useUser()

    await refreshUser()

    if (isLoggedIn.value) return navigateTo({ path: localePath(getAccountPermalink()) })
  } catch (error) {
    // Handle the case where composables are called outside of setup context
    // This can happen during logout navigation
    console.warn('loggedInRedirect middleware: Unable to check user status during navigation: \n', error)
    return
  }
})
